<template lang="pug">
  a.pdp-missing-advisor.bg-gray-light.text-left.text-color-1.xs-f-small.lg-f-medium.max-at-tweak(v-if="showMissingAdvisor" :href="advisorUrl")
    | Answer a few quick questions to reveal your perfect shade
    span.icon-arrow-forward.xs-f-large.md-f-xlarge.max-at-tweak

</template>

<script>
  import { mapState } from "vuex";


  export default {
    name: "PdpMissingAdvisor",

    computed: {
      ...mapState('pdp', ['product']),
      ...mapState('colorAdvisor', ['advisorCompleted', 'lightWorksQuizCompleted']),

      rectype() {
        if (this.product.product_type == 'light_works') {
          return 'lw';
        } else if (this.product.product_type == 'root_touch_up') {
          return 'rtu';
        } else if (this.product.product_type == 'root_reboot') {
          return 'rrb';
        } else if (this.product.product_type == 'color_kit') {
          return 'color';
        } else if (this.product.product_type == 'root_perfection') {
          return '';
        }

        return null;
      },

      showMissingAdvisor() {
        if (this.rectype == 'lw') {
          return !this.lightWorksQuizCompleted;
        } else {
          return !this.advisorCompleted && (!!this.rectype || this.product.product_type == 'root_perfection' || this.product.product_type == 'colorwonder');
        }
      },

      advisorUrl() {
        return `/color-advisor${ this.rectype ? '?rectype=' + this.rectype : '' }`;
      }
    }
  };
</script>

<style scoped lang="stylus">
  .pdp-missing-advisor
    position relative
    padding 1em 1.5em
    padding-right 3.5em
    display block
    width 100%
    background-color color-pale-blue
    border-radius 0.25em

    .icon-arrow-forward
      position absolute
      top 50%
      right 0.5em
      margin-top -0.75em

</style>
